import { render, staticRenderFns } from "./PaycometIframeWrapper.vue?vue&type=template&id=5e90ded0"
import script from "./PaycometIframeWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./PaycometIframeWrapper.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports